import { useState } from "react";
import DiscoverySourceModal from "./DiscoverySourceModal";
import PropertyRangeModal from "./PropertyRangeModal";
import UsageSelectionModal from "./UsageSelectionModal";
import UserGoalsModal from "./UserGoalsModal";
import UserRoleSelectionModal from "./UserRoleSelectionModal";
import WelcomeOnboardingModal from "./WelcomeOnboardingModal";
import { useNavigate } from "react-router-dom";

const LLOnboardingSteps = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    skor_usage: "",
    professional_usage_type: "",
    properties_owned: "",
    ll_use_case: [],
    landing_source: "",
  });

  const handleCompleteStep = () => {
    navigate("/workspace-dashboard");
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <UsageSelectionModal
              progressStep={currentStep}
              setCurrentStep={setCurrentStep}
              setFormData={setFormData}
              formData={formData}
            />
          </>
        );
      case 1:
        return (
          <>
            <UserRoleSelectionModal
              progressStep={currentStep}
              setCurrentStep={setCurrentStep}
              setFormData={setFormData}
              formData={formData}
            />
          </>
        );
      case 2:
        return (
          <>
            <PropertyRangeModal
              progressStep={currentStep}
              setCurrentStep={setCurrentStep}
              setFormData={setFormData}
              formData={formData}
            />
          </>
        );
      case 3:
        return (
          <>
            <UserGoalsModal
              progressStep={currentStep}
              setCurrentStep={setCurrentStep}
              setFormData={setFormData}
              formData={formData}
            />
          </>
        );
      case 4:
        return (
          <>
            <DiscoverySourceModal
              progressStep={currentStep}
              setCurrentStep={setCurrentStep}
              setFormData={setFormData}
              formData={formData}
            />
          </>
        );
      case 5:
        return (
          <>
            <WelcomeOnboardingModal handleCompleteStep={handleCompleteStep} />
          </>
        );
    }
  };
  return <>{renderStep()}</>;
};
export default LLOnboardingSteps;
